<template>
  <div class="card h-100">
    <div class="card-header"><strong>{{ title }}</strong></div>
    <div class="card-body">
      <div class="row g-3 text-center mb-3">
        <div class="col-4">
          <small class="text-muted d-block">{{ countLabel }}</small>
          <strong class="fs-5">{{ numberBR(count) }}</strong>
        </div>
        <div class="col-4">
          <small class="text-muted d-block">Total</small>
          <strong class="fs-5">{{ moneyBR(total) }}</strong>
        </div>
        <div class="col-4">
          <small class="text-muted d-block">Média</small>
          <strong class="fs-5">{{ moneyBR(average) }}</strong>
        </div>
      </div>
      <p v-if="note" class="text-muted small mb-2">
        <i class="fa-solid fa-circle-info me-1"></i>{{ note }}
      </p>
      <DashRankList :items="items" empty-msg="Sem dados de LTV ainda." />
    </div>
  </div>
</template>

<script>
import { moneyBR, numberBR } from "@/utils/dashboardCharts";
import DashRankList from "./DashRankList.vue";

export default {
  name: "DashLtvBlock",
  components: { DashRankList },
  props: {
    title: { type: String, required: true },
    countLabel: { type: String, default: "Pessoas" },
    count: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    average: { type: Number, default: 0 },
    // já no formato do DashRankList: [{ id, name, value, linkTo }]
    items: { type: Array, default: () => [] },
    note: { type: String, default: "" },
  },
  methods: { moneyBR, numberBR },
};
</script>
